<template>
  <div id="app">
    <TopNavigation />
    <router-view />
    <!-- <SocialFooter /> -->
  </div>
</template>

<script setup>
import TopNavigation from '@/components/TopNavigation.vue';
// import SocialFooter from '@/components/SocialFooter.vue';
</script>

<style lang="scss">
@use '@/assets/scss/_index' as *;

#app {
  background: transparent;
}

a.router-link-active {
  opacity: 0.4;

  &:hover {
    text-decoration: none;

    @media only screen and (min-width: $tbPortrait) {
      text-decoration: line-through;
    }
  }
}
</style>
